import React, { useState, useEffect } from "react";
import { locationInput } from "./Utils/locationsInput";
import { Button } from "@mui/material";
import camera from "../../../../assets/DigitalMarketing/image/photo_camera.svg";
import MultiSelect from "./Component/MultiSelect";
import {
  useAddLocationsMasterMutation,
  useGetProcedureTemplatesQuery,
  useUpdateLocationsMastersMutation,
} from "../../../../Service/Masters";
import useSnackbar from "../../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../../Component/DigitalMarketing/Toast";
import editpencil from "../../../../assets/DigitalMarketing/image/editpencil.svg";
import BackdropLoader from "../../../../Component/DigitalMarketing/BackDropLoader";
import { Branch_BUCKET_URL } from "../../../../Service/api/ApiUrls";

const LocationDetails = (props) => {

  const { updateData, setShow, refetch } = props;
  const [submit, setSubmit] = useState(false);
  const [formData, setFormData] = useState({
    branchName: updateData.branchName || "",
    city: updateData.city || "",
    email: updateData.email || "",
    address: updateData.address || "",
    pincode: updateData.pincode || "",
    state: updateData.state || "",
    country: updateData.country || "",
    headquarters: updateData.headquarters ? 1 : 0 || 0,
    phone: updateData.phone || "",
    branchImage:
      `${Branch_BUCKET_URL}/${updateData?.imagePath}${updateData?.imageName}` || null,
    password: updateData?.password || "",
  });

  const [errorColor, setErrorColor] = useState(false);
  const [imageChanged, setImageChanged] = useState(false);
  const [options, setOptions] = useState(updateData.procedures || []);
  const [selectedImage, setSelectedImage] = useState(
    updateData?.id
      ? `${Branch_BUCKET_URL}/${updateData?.imagePath}${updateData?.imageName}`
      : null
  );

  const [multiSelectValues, setMultiSelectValues] = useState(
    updateData.procedures?.map((proc) => proc.procedure) || []
  );
  const [procedures, setProcedures] = useState(updateData.procedures || []);
  const fileInputRef = React.useRef(null);
  const { open, message, openSnackBar, type } = useSnackbar();
  const pagi = {
    pageNo: 1,
    name: "",
  };
  const { data } = useGetProcedureTemplatesQuery<any>(pagi, {
    refetchOnMountOrArgChange: true,
  });
  const [addLocations, { isLoading: addLoading }] =
    useAddLocationsMasterMutation();
  const [updateLocations, { isLoading: updateLoading }] =
    useUpdateLocationsMastersMutation();

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file && updateData?.id) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (validTypes.includes(file.type)) {
        const imageUrl = URL.createObjectURL(file);
        setSelectedImage(imageUrl);
        setFormData((prev) => ({
          ...prev,
          branchImage: file,
        }));
        const newFormData = new FormData();
        newFormData.append("branchImage", formData.branchImage);
        setImageChanged(true);
      } else {
        openSnackBar(
          "Please upload a valid image (JPG, JPEG, or PNG)",
          "error"
        );
      }
    } else {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (validTypes.includes(file.type)) {
        const imageUrl = URL.createObjectURL(file);
        setSelectedImage(imageUrl);
        setFormData((prev) => ({
          ...prev,
          branchImage: file,
        }));
        setImageChanged(true);
      } else {
        openSnackBar(
          "Please upload a valid image (JPG, JPEG, or PNG)",
          "error"
        );
      }
    }
  };

  const handleChangeInfo = (e) => {
    let { name, type, checked, value } = e.target;
    if (name === 'email') {
      value = value.replace(/[^a-zA-Z0-9@._-]/g, '');
    }
     else if (name === 'phone' ) {
      value = value.replace(/[^0-9]/g, '');
      value = value.slice(0, 10);
    }
     else if ( name === 'pincode') {
      value = value.replace(/[^0-9]/g, '');
      value = value.slice(0,6);
    }
    else if (name != 'password' ) {
       value = value.replace(/^[\s]+|[^a-zA-Z0-9 ]/g, '');
    } 
    // Check if the input type is a checkbox
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value; // Set to 1 if checked, else 0

    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleMultiSelectChange = (event) => {
    const {
      target: { value },
    } = event;
    setMultiSelectValues(value);
    const selectedOptions = options.filter((option) =>
      value.includes(option.label)
    );
    setProcedures(
      selectedOptions.map((option) => {
        const existingProcedure = procedures.find(
          (proc) => proc.procedure === option.label
        );
        return existingProcedure?.id
          ? { procedure: option.label, id: existingProcedure.id }
          : { procedure: option.label };
      })
    );
  };

  useEffect(() => {
    if (data?.data) {
      const newOptions = data.data.map((proc) => ({
        value: proc.id,
        label: proc.procedureTitle,
      }));
      setOptions(newOptions);
    }
  }, [data]);

  const handleSubmit = async () => {
    setSubmit(true);
    const missingFields = Object.entries(formData).filter(
      ([key, value]) => !["headquarters", "password"].includes(key) && !value
    );

    if (missingFields.length > 0) {
      openSnackBar("Fill required data", "error");
      return;
    }
    const newFormData = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (key !== "procedures" && key !== "branchImage") {
        newFormData.append(key, value);
      }
    });
    if (procedures.length > 0) {
      newFormData.append("procedures", JSON.stringify(procedures));
    }
    if (formData.branchImage && imageChanged) {
      newFormData.append("branchImage", formData.branchImage);
    }

    if (updateData?.id) {
      try {
        newFormData.append("roleId", "1");
        await updateLocations({
          id: updateData.id,
          newFormData,
        }).unwrap();
        refetch();
        openSnackBar("Updated Successfully");
        setTimeout(() => {
          setShow(false);
        }, 350);
      } catch (error: any) {
        if (error?.status === 400) {
          openSnackBar(error?.data?.error, "error");
        }
      }
    } else {
      try {
        newFormData.append("roleId", "1");
        newFormData.append("activeStatus", "1");
        await addLocations(newFormData).unwrap();
        refetch();
        openSnackBar("Created Successfully");
        setTimeout(() => {
          setShow(false);
        }, 350);
      } catch (error: any) {
        if (error?.status === 400) {
          openSnackBar(error?.data?.error, "error");
        }
      }
    }
  };

  return (
    <>
      <BackdropLoader loader={addLoading || updateLoading} />
      <Toast open={open} type={type} message={message} />
      <div>
        <div className="mt-3">
          <span className="f-18 fw-700">
            {updateData?.id ? "Edit Branch" : "Add Branch"}
          </span>
        </div>

        <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
          <div
            className="image-preview-container"
            style={{ position: "relative" }}
          >
            {selectedImage && (
              <img
                src={selectedImage}
                alt="img"
                style={{ width: "100px", height: "100px", borderRadius: "50%" }}
              />
            )}
            <img
              onClick={triggerFileInput}
              src={editpencil}
              alt="Edit Icon"
              style={{
                position: "absolute",
                top: "35%",
                left: "35%",
                width: "30%",
                height: "30%",
                cursor: "pointer", // Add pointer cursor for better UX
              }}
            />
          </div>

          <input
            type="file"
            ref={fileInputRef}
            hidden
            accept="image/*"
            onChange={handleImageChange}
          />
          <div
            onClick={triggerFileInput}
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              backgroundColor: selectedImage ? "transparent" : "#e0e0e0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            {!selectedImage && <img src={camera} alt="Camera Icon" />}
          </div>

          <div className="d-flex justify-content-center align-items-center">
            <input
              type="text"
              placeholder="Branch Name"
              name="branchName"
              value={formData.branchName}
              onChange={handleChangeInfo}
              style={{ border: errorColor && submit ? "1px solid red" : "" }}
            />
          </div>
        </div>

        <div className="mt-3">
          <span className="f-18 fw-500">Branch Info</span>
        </div>

        {locationInput.map((a, i) => {
          if (a.name === "password" && updateData?.id) {
            return null;
          }
          return (
            <div key={i}>
              {a.name === "headquarters" ? ( // Check if the input is a checkbox
                <div className="col-7 mt-3 d-flex justify-content-between">
                  <span className="det-label">{a.label}</span>
                  <label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name={a.name}
                      checked={formData[a.key] === 1} // Check if headquarters is 1
                      onChange={handleChangeInfo}
                    />
                  </label>
                </div>
              ) : (
                // : a.tag === "multi" ? (
                //   <div className="d-flex justify-content-between mt-3">
                //     <div className="det-label">Procedure</div>
                //     <div>
                //       <MultiSelect
                //         styles="select"
                //         option={options}
                //         value={multiSelectValues}
                //         onChange={handleMultiSelectChange}
                //         isLoading={isLoading}
                //       />
                //     </div>
                //   </div>
                // )
                <div className="input-custom mt-2">
                  <a.tag
                    img={a.img}
                    label={a.label}
                    name={a.name}
                    value={formData[a.key] || ""}
                    handleChange={handleChangeInfo}
                    validation={a.validation}
                    keyName={a.key}
                    submit={submit}
                  />
                </div>
              )}
            </div>
          );
        })}
        <div className="d-flex justify-content-center mt-4 mb-4">
          <Button
            variant="contained"
            type="button"
            id="btn-save"
            onClick={handleSubmit}
          >
            Save
          </Button>
        </div>
      </div>
    </>
  );
};

export default LocationDetails;
